module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-wrapper",
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        return _vm.$emit('close')
      }
    }
  }, [_c('div', {
    staticClass: "bg-overlay fadeIn animated",
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.$emit('close')
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal fadeInUp animated",
    style: (_vm.modalStyle)
  }, [_c('div', {
    staticClass: "modal__close icon__bg-circle",
    style: ({
      'color': _vm.closeCrossColor
    }),
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.$emit('close')
      }
    }
  }, [_c('span', {
    staticClass: "icon-cross2"
  })]), _vm._v(" "), _vm._t("body", function() {
    return [_c('h1', [_vm._v("Vil du slette?")])]
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4ab73c5c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Subjects/Modal.vue
// module id = 1905
// module chunks = 1